function Campaign(data) {
    this.code = data.code.toString().toLowerCase();
    this.link = data.link;
    this.title = data.title;
    this.sub_title = data.sub_title;
}

Campaign.prototype.valid = function(value) {
    if (value.toString().toLowerCase() == this.code) return true;
    return false;
};

Campaign.prototype.timeExpired = function(value) {
    var now = new Date().getTime();
    var expired = new Date(value).getTime();
    var day = Math.floor((expired - now) / (24 * 3600 * 1000));
    return day < 0;
};

Campaign.prototype.addAlert = function() {
    var msg = this.title + '<a style="color:blue;text-decoration: underline;" href="' + this.link + '" target="_blank">' + this.sub_title + '</a>';
    $(".hs-success-code-discount").find(".notice__text").html(msg);
    $(".hs-success-code-discount").removeClass("hide");
};

Campaign.prototype.clickApply = function() {
    var self = this;
    this.btn_apply = $("button.hs-apply-discount.hs-event-static");
    this.btn_apply.click();
    setTimeout(function() {
        var not_valid = self.discountNotValid();
        console.log({ not_valid });
        if (not_valid) self.addAlert();
    }, 3000);
};

Campaign.prototype.discountNotValid = function() {
    var msg = $(".hs-add-discount").find(".hs--content--warning").find(".notice__text").html();
    var regx = new RegExp(".*isn.t valid.*");
    return regx.test(msg);
};

Campaign.prototype.girftBuyOneGetOne = function(code) {
    if (this.loop) {
        clearTimeout(this.loop);
    }

    this.loop = setTimeout(function() {
        if (this.valid(code)) {
            this.clickApply();
        }
    }.bind(this), 300);
};

$(document).ready(function() {
    var camp = new Campaign({
        code: 'B1G1',
        link: "https://slimcase.co/pages/about-buy-1-get-1-promotion",
        title: "The discount not applicable. ",
        sub_title: "More details"
    });

    $("body").on("keyup", "#hs-id-discount", function() {
        var code = $(this).val();
        camp.girftBuyOneGetOne(code);
    });
});
